import {
    ProductListContainer as SourceProductListContainer,
    mapDispatchToProps
} from 'SourceComponent/ProductList/ProductList.container';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getQueryParam, setQueryParams } from 'Util/Url';

import { HOME_PAGE, SEARCH } from 'Component/Header/Header.config';
import Event, {
    EVENT_GTM_IMPRESSIONS_PLP,
    EVENT_GTM_IMPRESSIONS_HOME,
    EVENT_GTM_IMPRESSIONS_SEARCH
} from 'Util/Event';

export class ProductListContainer extends SourceProductListContainer {

    static defaultProps = {
        ...SourceProductListContainer.defaultProps,
        pageSize: 16
    };

    componentDidUpdate(prevProps) {
        const { sort, search, filter, pages, category } = this.props;
        const { sort: prevSort, search: prevSearch, filter: prevFilter, pages: prevPages, category: prevCategory } = prevProps;

        const { pagesCount } = this.state;
        const pagesLength = Object.keys(pages).length;

        if (pagesCount !== pagesLength) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ pagesCount: pagesLength });
        }

        if (
            search !== prevSearch ||
            JSON.stringify(sort) !== JSON.stringify(prevSort) ||
            JSON.stringify(filter) !== JSON.stringify(prevFilter) ||
            JSON.stringify(category) !== JSON.stringify(prevCategory)
        ) {
            this.requestPage(this._getPageFromUrl());
            this._scrollTop();
        }

        if (
            Object.keys(prevPages)[0] && Object.keys(pages)[0] !== Object.keys(prevPages)[0]
        ) {
            this._scrollTop();
        }

        this._updateImpressions(prevProps);
    }

    _scrollTop() {
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            window.scrollTo(0, 1);
        } else {
            window.scrollTo(0, 0);
        }
    }

    _updateImpressions(prevProps) {
        const {
            pages, isLoading, selectedFilters: filters,
            category = {}
        } = this.props;
        const { isLoading: prevIsLoading, pages: prevPages } = prevProps;
        const currentPage = getQueryParam('page', location) || 1;

        if (!Object.keys(pages || {}).length ||
            !Object.keys(pages[currentPage] || {}).length ||
            isLoading ||
            isLoading === prevIsLoading
        ) {
            return;
        }

        const { currentRouteName } = window;

        if (currentRouteName === HOME_PAGE) {
            Event.dispatch(EVENT_GTM_IMPRESSIONS_HOME, { items: pages[currentPage], filters });
        } else if (currentRouteName === SEARCH) {
            if (JSON.stringify(prevPages) !== JSON.stringify(pages)) {
                Event.dispatch(EVENT_GTM_IMPRESSIONS_SEARCH, {
                    items: pages[currentPage], filters
                });
            }
        } else {
            Event.dispatch(EVENT_GTM_IMPRESSIONS_PLP, {
                items: pages[currentPage], filters, category
            });
        }
    }

    /**
     * We want the outer observer (in ProductList) to update the URL on scroll.
     * So we return true here.
     */
    _getIsInfiniteLoaderEnabled() {
        return true;
    }

    // Manual load functions remain the same
    loadMorePage = () => {
        const { isPageLoading, pages, totalItems, pageSize } = this.props;
        if (isPageLoading) return;

        // Determine the maximum loaded page
        const keys = Object.keys(pages).map(Number);
        const maxPage = keys.length ? Math.max(...keys) : 1;
        const totalPages = Math.ceil(totalItems / pageSize);

        // Only load if there is a next page.
        if (maxPage < totalPages) {
            const newPage = maxPage + 1;
            // Call parent's loadPage method with next=true.
            super.loadPage(true);
            this.updatePage(newPage);
        }
    };

    loadPreviousPage = () => {
        const { isPageLoading, pages } = this.props;
        if (isPageLoading) return;

        // Determine the minimum loaded page.
        const keys = Object.keys(pages).map(Number);
        const minPage = keys.length ? Math.min(...keys) : 1;
        if (minPage <= 1) return; // no previous pages

        const newPage = minPage - 1;
        // Call parent's loadPage method with next=false.
        super.loadPage(false);
        this.updatePage(newPage);
    };

    updatePage(pageNumber) {
        setQueryParams({
            page: pageNumber === 1 ? '' : pageNumber
        }, this.props.location, this.props.history);
    }

    // Override containerFunctions to use our manual load functions.
    containerFunctions = {
        loadPrevPage: this.loadPreviousPage.bind(this),
        loadPage: this.loadMorePage.bind(this),
        updatePage: this.updatePage.bind(this)
    };
}

export default withRouter(connect(null, mapDispatchToProps)(ProductListContainer));
